import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import ClubbieInput from "../../components/ClubbieInput/ClubbieInput";
// TODO: Legacy file - needs full refactor to use categories instead of divisions/seasons
// import {
//   selectDivision,
//   selectSeason,
//   updateSeason,
// } from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import "./CreateTournamentInput.css";

const TeamRegistrationFee = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  // TODO: Legacy - selectedDivision/selectedSeason removed, using selectedCategory
  const selectedDivision = useSelector(
    (state) => state.tournament.selectedCategory
  );
  const selectedSeason = useSelector(
    (state) => state.tournament.selectedCategory
  );
  const [registrationFee, setRegistrationFee] = useState();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!selectedDivision || !selectedSeason) {
      navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CREATE_TOURNAMENT_DIVISION);
    }
  }, [selectedDivision, selectedSeason, navigate]);

  const validateInput = () => {
    const newErrors = {};
    if (registrationFee < 0) {
      newErrors.registrationFee = "Registration fee cannot be negative";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    try {
      if (!validateInput()) {
        return;
      }

      setIsLoading(true);
      if (selectedTournament?.id && selectedDivision && selectedSeason) {
        // TODO: Legacy - updateSeason, selectDivision, selectSeason removed
        // const seasonData = {
        //   registrationFee: registrationFee,
        // };
        //
        // const result = await dispatch(
        //   updateSeason({
        //     tournamentId: selectedTournament.id,
        //     divisionId: selectedDivision._id,
        //     seasonId: selectedSeason._id,
        //     seasonData,
        //   })
        // ).unwrap();
        //
        // if (result) {
        //   const updatedDivision = result.divisions.find(
        //     (div) => div._id === selectedDivision._id
        //   );
        //   if (updatedDivision) {
        //     dispatch(selectDivision(updatedDivision));
        //
        //     const updatedSeason = updatedDivision.season.find(
        //       (s) => s._id === selectedSeason._id
        //     );
        //     if (updatedSeason) {
        //       dispatch(selectSeason(updatedSeason));
        //     }
        //   }
        //
        //   toast.success("Registration fee updated successfully!");
        //   navigate(DASHBOARD_STACK.HOME);
        // } else {
        //   throw new Error("Failed to update registration fee");
        // }
      }
    } catch (error) {
      toast.error(error.message || "Failed to update registration fee");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <p className="registration-fee-text" style={{ fontSize: "18px" }}>
        Add a Team Registration Fee*
      </p>
      <p className="registration-fee-text">
        This is how much it'll cost a team to enter your competition (you can
        set it as £0 if it's free to enter!)
      </p>
      <ClubbieInput
        type="number"
        containerClassName="input-section"
        value={registrationFee}
        onChange={(e) => setRegistrationFee(e.target.value)}
        placeholder="Enter fee per team (e.g. £30)"
        min="0"
      />
      {errors.registrationFee && (
        <div className="error-message">{errors.registrationFee}</div>
      )}

      <ClubbieButton
        className="clubbie-button"
        onClick={handleNext}
        isLoading={isLoading}
        disabled={!registrationFee}
      >
        Next
      </ClubbieButton>
    </>
  );
};

export default TeamRegistrationFee;
